module.exports = __webpack_public_path__ + "static/media/logowhite.dcf86f3f.png";